export default "__VITE_ASSET__DhfXgV_E__"